import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import Main from './Main';
import './App.scss';
import './styles/normalize.scss';
import './styles/globals.scss';
import { checkAuthRequest, checkAuthFailed } from 'store/actions';

const App = props => {
  useEffect(() => {
    localStorage.setItem('view', 'list');

    // Office 365 may return to /login?code=... or /?code=... (OAUTH_REDIRECT_URL root).
    // Skip checkAuth so it cannot race with the code exchange.
    const params = new URLSearchParams(window.location.search);
    const isOAuthCallback = Boolean(params.get('code'));

    if (isOAuthCallback) {
      props.skipCheckAuth('oauth_callback');
    } else {
      props.checkAuth();
    }
  }, [props.checkAuth, props.skipCheckAuth]);

  return (
    <div className="App">
      <>
        <BrowserRouter>
          <Main />
        </BrowserRouter>
      </>
    </div>
  );
};

const mapStatetoProps = store => ({
  currentUser: store.auth.currentUser
});
const mapDispatchToProps = {
  checkAuth: checkAuthRequest,
  skipCheckAuth: checkAuthFailed
};
export default connect(mapStatetoProps, mapDispatchToProps)(App);
